import React from 'react'
import Services from '../HomePage/Components/Services'
import CategoryHeader from '../HomePage/Components/Category-header/CategoryHeader'

const Workers = () => {
  return (
    <div className=' mx-5'>
        <div className='w-full mt-5'>
           <CategoryHeader/>
        </div>
        <Services/>
    </div>
  )
}

export default Workers